<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="3">
        <YearsComponent @change="onYearSelected" />
      </el-col>
      <el-col :span="3">
        <AsignedThecnicians @ThecnicianChaged="onThecnicianChange" />
      </el-col>
      <el-col :span="3">
        <CustomerServiceSelector
          @CustomerServiceChanged="onCustomerServiceChange"
        />
      </el-col>
      <el-col :span="3">
        <RequestTypeSelector
          :type.sync="requestType"
          @change="onResquestTypeChange"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import YearsComponent from "@/components/Global_System/YearsComponent";
import AsignedThecnicians from "@/components/requests/thecnicians/AsignedThecnicians";
import RequestTypeSelector from "@/components/Company/RequestTypeSelector.vue";
import CustomerServiceSelector from "@/components/customer_service/filters/CustomerServiceSelector";

export default {
  name: "ReportByProductByMonthFilters",
  components: {
    YearsComponent,
    AsignedThecnicians,
    CustomerServiceSelector,
    RequestTypeSelector
  },
  data() {
    return {
      requestType: ""
    };
  },
  methods: {
    onYearSelected(year) {
      this.$emit("onYearSelected", year);
    },
    onThecnicianChange(thecnicianId) {
      this.$emit("thecnicianChaged", thecnicianId);
    },
    onResquestTypeChange(val) {
      this.requestType = val;
      this.$emit("resquestTypeChanged", val);
    },
    onCustomerServiceChange(val) {
      this.$emit("customerServiceChanged", val);
    }
  }
};
</script>

<style lang="scss" scoped></style>
